module.exports = __webpack_public_path__ + "img/图片9.ef3295ad.png";